// extracted by mini-css-extract-plugin
export default {"toolbar":"MileageLogsStats_toolbar__TzTFe","stat":"MileageLogsStats_stat__WigHv","statValue":"MileageLogsStats_statValue__rJBJp","statName":"MileageLogsStats_statName__HDLy-"};